(() => {
  document.querySelectorAll('[data-genre-packs]').forEach(root => {
    if (root.dataset.gpReady) return;
    const search = root.querySelector('[data-gp-search]');
    const input = search && search.querySelector('input');
    const clear = root.querySelector('[data-gp-clear]');
    const empty = root.querySelector('[data-gp-empty]');
    if (!input || !clear || !empty) return;
    root.dataset.gpReady = 'true';
    const groups = Array.from(root.querySelectorAll('[data-gp-group]'));
    const normalize = text => text.normalize('NFKC').toLocaleLowerCase().trim();
    const filter = () => {
      const terms = normalize(input.value).split(/\s+/).filter(Boolean);
      let found = false;
      groups.forEach(group => {
        let visible = false;
        group.querySelectorAll('[data-gp-pack]').forEach(pack => {
          pack.hidden = !terms.every(term => normalize(pack.dataset.gpTerms).includes(term));
          visible = visible || !pack.hidden;
        });
        group.hidden = !visible;
        found = found || visible;
      });
      clear.hidden = terms.length === 0;
      empty.hidden = found;
    };
    input.addEventListener('input', filter);
    clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    search.hidden = false;
    filter();
  });
})();
